import { useEffect, useState } from "react";
import { cachedHttp } from "../../../services/httpService";
import getAlertChannels from "../../../services/alertChannelService";
import getDepthOfFields from "../../../services/depthOfFieldService";
import getRelevances from "../../../services/relevanceService";
import getSegments from "../../../services/segmentService";
import { listAllSensitivities } from "../../../services/sensitivityService";
import { getRecorderBrands } from "./captureDeviceService";

const EMPTY = {
  brands: [],
  alertChannels: [],
  depthOfFields: [],
  resolutions: [],
  bodySensitivities: [],
  bagSensitivities: [],
  relevances: [],
  segments: [],
};

function unwrap(resp) {
  const data = resp?.data ?? resp;
  if (Array.isArray(data)) return data;
  return data?.results ?? [];
}

function logFail(label) {
  return (err) => {
    console.warn(`[useForeignKeys] ${label} failed:`, err?.response?.status, err?.message || err);
    return null;
  };
}

export default function useForeignKeys() {
  const [state, setState] = useState({ ...EMPTY, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));

    Promise.all([
      getRecorderBrands().catch(logFail("recorder-brands")),
      getAlertChannels().catch(logFail("alert-channels")),
      getDepthOfFields().catch(logFail("depth-of-fields")),
      cachedHttp.get("/resolutions/").catch(logFail("resolutions")),
      listAllSensitivities().catch(logFail("sensitivities")),
      getRelevances().catch(logFail("relevances")),
      getSegments().catch(logFail("segments")),
    ])
      .then(([brands, alertCh, dof, reso, sensRaw, rel, seg]) => {
        if (cancelled) return;
        const sensitivities = unwrap(sensRaw);
        const next = {
          brands: Array.isArray(brands) ? brands : unwrap(brands),
          alertChannels: unwrap(alertCh),
          depthOfFields: unwrap(dof),
          resolutions: unwrap(reso),
          bodySensitivities: sensitivities.filter((s) => s.sensitivity_type === "body"),
          bagSensitivities: sensitivities.filter((s) => s.sensitivity_type === "bag"),
          relevances: unwrap(rel),
          segments: unwrap(seg),
          loading: false,
          error: null,
        };
        setState(next);
      })
      .catch((error) => {
        if (!cancelled) setState((s) => ({ ...s, loading: false, error }));
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
